import React from 'react';

const IconHelpCenter = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 6.5C10.3 5.2 8.2 4.5 6 4.5H3.5v13H6c2.2 0 4.3.7 6 2 1.7-1.3 3.8-2 6-2h2.5v-13H18c-2.2 0-4.3.7-6 2Z'
      stroke='#FF2D38'
      strokeWidth='1.8'
      strokeLinejoin='round'
    />
    <path d='M12 6.5v13' stroke='#FF2D38' strokeWidth='1.8' />
  </svg>
);

export default IconHelpCenter;
